import { useState, useEffect } from "react";
import Slider from "react-slick";
import { Triangle } from "react-loader-spinner";
import {
  getAbout,
  updateAbout,
  getHomePageData,
} from "../redux/admin/about-slice";
import {
  getDesignation,
  updateDesignation,
  addDesignation,
  deleteDesignation,
} from "../redux/admin/designation-slice";
import {
  getAwards,
  updateAward,
  addAward,
  deleteAward,
} from "../redux/admin/award-slice";
import { useDispatch, useSelector } from "react-redux";
import FileUpload from "./FileUpload";
import AwardForm from "./AwardForm";
import Gallery from "./Gallery";
// import DeleteModal from "./DeleteModal";
import { Link, useNavigate } from "react-router-dom";
import Membership from "./Membership";
import MembershipForm from "./MembershipForm";
import {
  addMembership,
  updateMembership,
} from "../redux/admin/membership-slice";
import TitleText from "./ui/TitleText";
import Connections from "./Connections";

const types = {
  journal: "JOURNAL ARTICLE",
  "working-paper": "WORKING PAPER",
  policy: "POLICY BRIEF",
};

const initialFormData = {
  title: "",
  company: "",
  location: "",
};

const initialAboutFormData = {
  name: "",
  motto: "",
  bio: "",
};

const initialAward = {
  title: "",
  year: "",
  image: "",
};

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { about, homePageData, isLoading } = useSelector(
    (state) => state.about,
  );
  const { designation } = useSelector((state) => state.designation);
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { awards } = useSelector((state) => state.award);
  const [formData, setFormData] = useState(initialFormData);
  const [aboutFormData, setAboutFormData] = useState(initialAboutFormData);
  const [isDesignationEditing, setIsDesignationEditing] = useState(false);
  const [designationId, setDesignationId] = useState(null);
  const [awardData, setAwardData] = useState(initialAward);
  const [isAwardEditing, setIsAwardEditing] = useState(false);
  const [awardId, setAwardId] = useState(null);
  const [openImageUpdateModal, setOpenImageUpdateModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  // const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isMembershipEditing, setIsMembershipEditing] = useState(false);
  const [membershipData, setMembershipData] = useState({
    hoverText: "",
    imageLink: "",
  });
  const [membershipId, setMembershipId] = useState(null);

  const settings = {
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    // adaptiveHeight: true,
  };

  useEffect(() => {
    dispatch(getAbout());
    dispatch(getDesignation());
    dispatch(getAwards());
    dispatch(getHomePageData());
  }, [dispatch]);

  const [imageEditing, setImageEditing] = useState(false);

  const handleSaveDesignation = () => {
    if (formData.title === "") {
      alert("Title fields are required");
      return;
    }
    if (formData && designationId) {
      dispatch(updateDesignation({ formData, id: designationId })).then(
        (res) => {
          if (res.payload?.success) {
            dispatch(getDesignation());
          }
        },
      );
    } else {
      dispatch(addDesignation(formData)).then((res) => {
        console.log(res);
        if (res.payload?.success) {
          dispatch(getDesignation());
        }
      });
    }
    setIsDesignationEditing(false);
    setFormData(initialFormData);
    designationId && setDesignationId(null);
  };

  const handleUpdate = (d) => {
    setIsDesignationEditing(true);
    setDesignationId(d._id);
    setFormData({
      title: d.title,
      company: d.company,
      location: d.location,
    });
  };

  const handleDeleteDesignation = (id) => {
    dispatch(deleteDesignation(id)).then((res) => {
      if (res.payload?.success) {
        dispatch(getDesignation());
      }
    });
  };

  const handleEditClick = () => {
    const { name, motto, bio } = about;
    setAboutFormData({ name, motto, bio });
    setIsEditing(true);
  };

  const handleSaveBio = () => {
    dispatch(updateAbout(aboutFormData)).then((res) => {
      if (res.payload?.success) {
        dispatch(getAbout());
      }
    });
    setIsEditing(false);
    setAboutFormData(initialAboutFormData);
  };

  // image section
  const handleImageUpdateModal = () => {
    setOpenImageUpdateModal(true);
  };

  // award section
  const handleSaveAward = (uploadedImageUrl) => {
    if (awardData.title === "" || awardData.year === "") {
      alert("Title and Year fields are required");
      return;
    }
    const payload = { ...awardData, image: uploadedImageUrl };

    if (awardId) {
      dispatch(updateAward({ formData: payload, id: awardId })).then((res) => {
        if (res.payload?.success) {
          dispatch(getAwards());
        }
      });
    } else {
      dispatch(addAward(payload)).then((res) => {
        if (res.payload?.success) {
          dispatch(getAwards());
        }
      });
    }
    setIsAwardEditing(false);
    setAwardData(initialAward);
    awardId && setAwardId(null);
  };

  const handleSaveMembership = (uploadedImageUrl) => {
    if (membershipData.hoverText === "") {
      alert("Hover Text and Image Link fields are required");
      return;
    }
    const payload = { ...membershipData, imageLink: uploadedImageUrl };
    if (membershipId) {
      dispatch(updateMembership({ formData: payload, id: membershipId })).then(
        (res) => {
          if (res.payload?.success) {
            dispatch(getHomePageData());
          }
        },
      );
    } else {
      dispatch(addMembership(payload)).then((res) => {
        if (res.payload?.success) {
          dispatch(getHomePageData());
        }
      });
    }
    setIsMembershipEditing(false);
    setMembershipData({ hoverText: "", imageLink: "" });
    membershipId && setMembershipId(null);
  };

  const handleUpdateAward = (a) => {
    setIsAwardEditing(true);
    setAwardId(a._id);
    const { title, year, image } = a;
    setAwardData({ title, year, image });
  };

  const handleDeleteAward = (id) => {
    dispatch(deleteAward(id)).then((res) => {
      if (res.payload?.success) {
        dispatch(getAwards());
      }
    });
  };

  const handleUpdateMembership = (m) => {
    setIsMembershipEditing(true);
    setMembershipId(m._id);
    const { hoverText, imageLink } = m;
    setMembershipData({ hoverText, imageLink });
  };

  const handleNewsPage = (id) => {
    navigate(`/news-events/${id}`);
  };

  if (isLoading)
    return (
      <div className="fixed top-0 left-0 flex justify-center items-center h-full w-screen">
        <Triangle
          height="60"
          width="60"
          color="#4fa94d"
          ariaLabel="triangle-loading"
          wrapperStyle={{}}
          wrapperClassName=""
          visible={true}
        />
      </div>
    );

  return (
    <div className="mt-4 lg:mx-24 mx-4">
      {imageEditing && (
        <FileUpload
          setOpenModal={() => setImageEditing(false)}
          name="image"
          api="upload-pro-pic"
          text="Upload Profile Picture"
          oldImage={null}
        />
      )}

      {isDesignationEditing && (
        <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-25 z-50 flex justify-center items-center">
          <div className="w-96 h-fit p-4 bg-white text-black rounded space-y-4">
            <div className="space-y-2">
              <p className="text-center text-lg font-semibold p-2">
                Update Designation
              </p>
              <div className="flex items-center">
                <p className="w-20">Title</p>
                <input
                  className="px-2 border rounded flex-1"
                  type="text"
                  onChange={(e) =>
                    setFormData({ ...formData, title: e.target.value })
                  }
                  placeholder="Title"
                  value={formData?.title}
                />
              </div>
              <div className="flex items-center">
                <p className="w-20">Company</p>
                <input
                  className="px-2 border rounded flex-1"
                  type="text"
                  onChange={(e) =>
                    setFormData({ ...formData, company: e.target.value })
                  }
                  placeholder="Company"
                  value={formData?.company}
                />
              </div>
              <div className="flex items-center">
                <p className="w-20">Locaton</p>
                <input
                  className="px-2 border rounded flex-1"
                  type="text"
                  onChange={(e) =>
                    setFormData({ ...formData, location: e.target.value })
                  }
                  placeholder="Locaton"
                  value={formData?.location}
                />
              </div>
            </div>
            <div className="flex justify-center gap-4">
              <button className="save" onClick={handleSaveDesignation}>
                Save
              </button>
              <button
                className="cancel"
                onClick={() => {
                  setIsDesignationEditing(false);
                  setFormData(initialFormData);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {openImageUpdateModal && (
        <Gallery
          setOpenModal={() => setOpenImageUpdateModal(false)}
          images={about?.banner}
          // images={images}
        />
      )}

      {isAwardEditing && (
        <AwardForm
          setIsAwardEditing={setIsAwardEditing}
          setAwardData={setAwardData}
          awardData={awardData}
          setAwardId={setAwardId}
          awardId={awardId}
          handleSaveAward={handleSaveAward}
          initialAward={initialAward}
        />
      )}

      {isMembershipEditing && (
        <MembershipForm
          setIsMembershipEditing={setIsMembershipEditing}
          setMembershipData={setMembershipData}
          membershipData={membershipData}
          setMembershipId={setMembershipId}
          handleSaveMembership={handleSaveMembership}
        />
      )}

      <div className="sm:flex gap-2">
        <div className="flex flex-col items-center sm:w-1/3 w-full p-2 gap-2">
          <div className="max-w-full w-56 h-64">
            <img
              src={about?.pro_pic}
              alt="profile"
              className="w-full h-full object-cover"
            />
          </div>
          {isAuthenticated && (
            <button
              onClick={() => setImageEditing(true)}
              className="save text-white"
            >
              Change Picture
            </button>
          )}
          <div className="text-center">
            <p className="font-bold text-xl">{about?.name}</p>
            {isAuthenticated && (
              <button
                onClick={() => setIsDesignationEditing(true)}
                className="save"
              >
                + Add Designation
              </button>
            )}
            {designation?.map((d, index) => (
              <div key={d.title}>
                <div className="my-3">
                  <p className="font-semibold">{d.title}</p>
                  <p>{d.company}</p>
                  <p>{d.location}</p>
                </div>
                {isAuthenticated && (
                  <div className="flex justify-center gap-4">
                    <button
                      className="fas fa-edit text-green-500"
                      onClick={() => handleUpdate(d)}
                    ></button>
                    <button
                      className="fas fa-trash text-red-400"
                      onClick={() => handleDeleteDesignation(d._id)}
                    ></button>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="flex-1 overflow-hidden">
          {isEditing ? (
            <div className="w-full">
              <textarea
                value={aboutFormData?.bio}
                onChange={(e) => setAboutFormData({ bio: e.target.value })}
                className="text-justify mb-4 w-full h-96 p-2 outline-none whitespace-pre-wrap"
              />
              <button
                className="border px-4 py-1 mb-4 rounded mr-4 save"
                onClick={handleSaveBio}
              >
                Save
              </button>
              <button
                className="border px-4 py-1 mb-4 rounded cancel"
                onClick={() => {
                  setIsEditing(false);
                  setAboutFormData(initialAboutFormData);
                }}
              >
                Cancel
              </button>
            </div>
          ) : (
            <div>
              <p className="text-justify mb-4 whitespace-pre-line">
                {about?.bio}
              </p>
              {isAuthenticated && (
                <button
                  className="save border px-4 py-1 mb-4 rounded"
                  onClick={handleEditClick}
                >
                  Edit
                </button>
              )}
            </div>
          )}

          <div className="w-full overflow-hidden pb-10">
            <Slider {...settings}>
              {about?.banner?.map((img, index) => (
                <div
                  key={index}
                  className="image-container border-4 border-indigo-950"
                >
                  <img src={img} alt="Certificate" />
                </div>
              ))}
            </Slider>
          </div>

          {isAuthenticated && (
            <button onClick={handleImageUpdateModal} className="edit">
              Update Image
            </button>
          )}
        </div>
      </div>

      {/* --------------------- News And Events --------------------- */}
      <TitleText title="News & Events" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
        {homePageData?.newsAndEvents?.map((newsAndEvent) => (
          <div
            key={newsAndEvent._id}
            className="relative group rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
          >
            {/* Background Image */}
            <div
              className="h-56 sm:h-64 md:h-72 bg-cover bg-center cursor-pointer"
              onClick={() => handleNewsPage(newsAndEvent._id)}
              style={{
                backgroundImage: `url(${
                  newsAndEvent.image || "/placeholder.jpg"
                })`,
              }}
            >
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-90 group-hover:opacity-100 transition-opacity duration-300"></div>

              {/* Content */}
              <div className="absolute bottom-4 left-4 right-4 text-white z-10">
                <span className="text-xs bg-sky-600 px-2 py-1 rounded-sm uppercase font-semibold tracking-wide">
                  {newsAndEvent.type === "news"
                    ? "News"
                    : newsAndEvent.type === "photo"
                      ? "Photo"
                      : newsAndEvent.type === "video"
                        ? "Video"
                        : "Event"}
                </span>

                <h3 className="text-base sm:text-lg font-semibold mt-2 line-clamp-2">
                  {newsAndEvent.title}
                </h3>

                {newsAndEvent.date && (
                  <p className="text-xs sm:text-sm text-gray-200">
                    {new Date(newsAndEvent.date).toLocaleDateString("en-GB", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })}
                  </p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 text-right">
        <Link
          to="/news-events"
          className="text-teal-500 font-semibold hover:text-teal-600"
        >
          Read More
        </Link>
      </div>

      {/* ----------------------- Publication ----------------------- */}
      <TitleText title="Recent Publications" />
      <div className="py-4"></div>
      {homePageData?.publications?.map((item, index) => (
        <div key={index} className="my-4 border-b pb-4 space-y-1">
          <p className="text-xs font-bold text-gray-500 mb-1">
            {types[item.category]}
          </p>
          <Link
            to={item.link}
            target="_blank"
            rel="noopener"
            className="text-lg text-slate-700 font-semibold hover:underline"
          >
            {item.title}
          </Link>
          <p className="text-sm text-gray-500 italic">{item.published}</p>
          <p className="text-slate-700">
            {item.authors.split(",").map((author, index) => {
              const trimmedAuthor = author.trim();
              const isKeyword = item.keywords.some(
                (keyword) =>
                  keyword.toLowerCase() === trimmedAuthor.toLowerCase(),
              );

              return (
                <span key={index}>
                  {isKeyword ? <strong>{trimmedAuthor}</strong> : trimmedAuthor}
                  {index !== item.authors.split(",").length - 1 && ", "}
                </span>
              );
            })}
          </p>
        </div>
      ))}
      <Link
        to="/publications"
        className="float-right text-teal-500 font-semibold hover-text-teal-600"
      >
        Read More
      </Link>

      {/* ------------------------Membership Section --------------------- */}
      <TitleText title="Professional Memberships" />
      {isAuthenticated && (
        <button
          onClick={() => setIsMembershipEditing(true)}
          className="edit mt-6"
        >
          + Add Membership
        </button>
      )}
      <Membership handleUpdateMembership={handleUpdateMembership} />

      {/* ----------------------- Award Section --------------------- */}
      <div className="my-4 py-8">
        <TitleText title="Awards" />
        <div className="py-4"></div>
        {isAuthenticated && (
          <button onClick={() => setIsAwardEditing(true)} className="edit mt-2">
            + Add Awards
          </button>
        )}
        {awards?.map((a) => (
          <div
            className="flex gap-2 p-2 border my-2 shadow h-fit bg-white"
            key={a.title}
          >
            <div className="w-28 h-20 flex items-center justify-center relative">
              <img
                src={a.image}
                alt="award"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 pl-4">
              <p className="font-semibold text-md">{a.title}</p>
              <p>{a.year}</p>
            </div>
            {isAuthenticated && (
              <div className="flex gap-4 h-fit my-auto">
                <button
                  className="fas fa-edit text-green-500"
                  onClick={() => handleUpdateAward(a)}
                ></button>
                <button
                  className="fas fa-trash text-red-400"
                  onClick={() => handleDeleteAward(a._id)}
                ></button>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* ------------------------ Connections Section --------------------- */}
      <TitleText title="Networks" />
      <div className="w-full flex justify-center bg-gray-100 pb-10">
        <div className="lg:w-[950px] w-full h-[400px] flex items-center justify-center">
          <Connections graphData={homePageData?.networkData} />
        </div>
      </div>
    </div>
  );
};

export default Home;
